import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar as MuiAvatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
const Avatar = ({ src, name, size = 40 }) => {
    const theme = useTheme();
    // Generate initials from name
    const getInitials = (fullName) => {
        if (!fullName)
            return '';
        const names = fullName.trim().split(' ');
        if (names.length === 1) {
            return names[0][0]?.toUpperCase() || '';
        }
        return (names[0][0] + names[names.length - 1][0])?.toUpperCase() || '';
    };
    // Check if image URL is valid
    const isValidImageUrl = (url) => {
        if (!url || !url.trim())
            return false;
        try {
            // Check if it's a valid URL
            const urlObj = new URL(url, window.location.origin);
            const pathname = urlObj.pathname.toLowerCase();
            // Check for blob-proxy URLs (backend proxy for blob storage)
            const isBlobProxy = pathname.includes('/blob-proxy');
            if (isBlobProxy)
                return true;
            // Check for common image extensions
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.gif', '.svg', '.bmp', '.ico'];
            const hasImageExtension = imageExtensions.some((ext) => pathname.endsWith(ext));
            // Check for common placeholder/default images to exclude
            const placeholderPatterns = [
                'user.png',
                'default.jpg',
                'placeholder.png',
                'avatar.png',
                'no-image',
                'default-user',
                'user-placeholder'
            ];
            const isPlaceholder = placeholderPatterns.some((pattern) => pathname.includes(pattern.toLowerCase()));
            return hasImageExtension && !isPlaceholder;
        }
        catch {
            // If URL parsing fails, assume it's not a valid image URL
            return false;
        }
    };
    const hasValidImage = isValidImageUrl(src);
    return (_jsx(MuiAvatar, { src: hasValidImage ? src || undefined : undefined, sx: {
            width: size,
            height: size,
            borderRadius: 1.5,
            bgcolor: theme.palette.background.neutral,
            color: theme.palette.action.active,
            ...theme.typography.subtitle2,
            fontWeight: 500
        }, children: !hasValidImage ? getInitials(name) : undefined }));
};
export default Avatar;
